import { Controller } from "@hotwired/stimulus"
import { FetchResponse } from "@rails/request.js"

export default class extends Controller {
  static targets = ["photoList"]

  declare readonly photoListTarget: HTMLElement

  async onAddAsset(event: CustomEvent<{ result: FetchResponse }>) {
    const addedElement = await event.detail.result.html
    this.photoListTarget.insertAdjacentHTML("beforeend", addedElement)
  }

  onDeletePicture(event) {
    event.currentTarget.remove()
  }

  onMovePicture(event) {
    if (event.detail.direction === "up") {
      const previousElement = event.currentTarget.previousElementSibling
      if (previousElement) {
        event.currentTarget.after(previousElement)
      }
    } else if (event.detail.direction === "down") {
      const nextElement = event.currentTarget.nextElementSibling
      if (nextElement) {
        event.currentTarget.before(nextElement)
      }
    }
  }

  async onUpdatePicture(event) {
    event.target.outerHTML = await event.detail.response.html
  }
}
